var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14369 4.92969H14.2712C14.6527 4.92969 15.0146 5.09917 15.2589 5.39231L18.1314 8.83934C18.324 9.0704 18.4294 9.36166 18.4294 9.66243V16.5011C18.4294 17.9213 17.2781 19.0725 15.858 19.0725H8.14369C6.72353 19.0725 5.57227 17.9213 5.57227 16.5011V7.50112C5.57227 6.08096 6.72353 4.92969 8.14369 4.92969ZM17.1437 16.5011V10.0725H15.2151C14.505 10.0725 13.9294 9.49691 13.9294 8.78683V6.2154H8.14369C7.43361 6.2154 6.85798 6.79104 6.85798 7.50112V16.5011C6.85798 17.2112 7.43361 17.7868 8.14369 17.7868H15.858C16.5681 17.7868 17.1437 17.2112 17.1437 16.5011ZM16.414 8.78683L15.2151 7.34815V8.78683H16.414ZM9.42941 13.2868C9.07437 13.2868 8.78655 12.999 8.78655 12.644C8.78655 12.2889 9.07437 12.0011 9.42941 12.0011H14.5723C14.9273 12.0011 15.2151 12.2889 15.2151 12.644C15.2151 12.999 14.9273 13.2868 14.5723 13.2868H9.42941ZM9.42941 15.8583C9.07437 15.8583 8.78655 15.5704 8.78655 15.2154C8.78655 14.8604 9.07437 14.5725 9.42941 14.5725H13.2865C13.6416 14.5725 13.9294 14.8604 13.9294 15.2154C13.9294 15.5704 13.6416 15.8583 13.2865 15.8583H9.42941ZM9.42941 10.7154C9.07437 10.7154 8.78655 10.4276 8.78655 10.0725C8.78655 9.7175 9.07437 9.42969 9.42941 9.42969H11.358C11.713 9.42969 12.0008 9.7175 12.0008 10.0725C12.0008 10.4276 11.713 10.7154 11.358 10.7154H9.42941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.027eda38c7ef73c6961e91e7c3f2c2be.svg";
export { ForwardRef as ReactComponent };